import { Pencil, Check, X } from 'lucide-react'

import { Button } from '@/components/ui/button'

interface DashboardEditModeProps {
  isEditing: boolean
  onStart: () => void
  onDone: () => void
  onCancel: () => void
}

export function DashboardEditMode({ isEditing, onStart, onDone, onCancel }: DashboardEditModeProps) {
  if (!isEditing) {
    return (
      <Button
        variant="outline"
        onClick={onStart}
        className="border-primary-200/50 hover:border-primary-300 hover:bg-primary-50/50 shadow-sm"
      >
        <Pencil className="mr-2 h-4 w-4 text-primary-600" />
        Edit Dashboard
      </Button>
    )
  }

  return (
    <div className="flex items-center gap-2">
      <Button
        onClick={onDone}
        className="bg-gradient-to-r from-emerald-500 to-emerald-600 hover:from-emerald-600 hover:to-emerald-700 shadow-sm"
      >
        <Check className="mr-2 h-4 w-4" />
        Done
      </Button>
      <Button variant="outline" onClick={onCancel} className="hover:bg-red-50 hover:text-red-600 hover:border-red-200">
        <X className="mr-2 h-4 w-4" />
        Cancel
      </Button>
    </div>
  )
}
